import type { ColumnDef } from '@vnetwork/ui/data';
import { Badge } from '@vnetwork/ui/primitives';
import type { AccessKey } from '@/api/s3';
import { RowMenu } from '../../components/RowMenu';
import { Mono } from '../s3-parts';

export interface AccessKeyRowActions {
  onToggle: (key: AccessKey) => void;
  onDelete: (key: AccessKey) => void;
}

function formatDate(raw?: string | null): string {
  if (!raw) return '—';
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? raw : d.toLocaleString();
}

/** Columns for the access-key table — status pill + kebab (enable/disable, delete). */
export function accessKeyColumns(actions: AccessKeyRowActions): ColumnDef<AccessKey, unknown>[] {
  return [
    {
      id: 'access_key_id',
      header: 'Access Key ID',
      cell: ({ row }) => <Mono>{row.original.access_key_id}</Mono>,
    },
    {
      id: 'user_name',
      header: 'User',
      size: 160,
      cell: ({ row }) => row.original.user_name || 'root',
    },
    {
      id: 'status',
      header: 'Status',
      size: 120,
      cell: ({ row }) => {
        const active = row.original.status === 'Active';
        return (
          <Badge tone={active ? 'success' : 'neutral'} appearance="subtle" size="sm">
            {active ? 'Active' : 'Inactive'}
          </Badge>
        );
      },
    },
    {
      id: 'create_date',
      header: 'Created',
      size: 200,
      cell: ({ row }) => <Mono>{formatDate(row.original.create_date)}</Mono>,
    },
    {
      id: 'actions',
      header: '',
      size: 64,
      cell: ({ row }) => {
        const active = row.original.status === 'Active';
        return (
          <RowMenu
            items={[
              {
                label: active ? 'Disable' : 'Enable',
                onSelect: () => actions.onToggle(row.original),
              },
              { label: 'Delete', onSelect: () => actions.onDelete(row.original), danger: true },
            ]}
          />
        );
      },
    },
  ];
}
